module.exports = __webpack_public_path__ + "static/media/github-icon.afe9d038.png";